import { useEffect, useRef } from "react";
import axios from "axios";
import { errorHandler, refreshLimit } from "../../../utility/helper";
import { logErrorToTelegram } from "../../../utility/action-helper";
import { formatTelegramLog } from "../../../utility/formatter-helper";
import { useDispatch, useSelector } from "react-redux";

const usePriceRefresh = ({
  cardsData,
  stopLossCFC,
  takeProfitCFC,
  setCardsData,
  active = true,
}) => {
  const {
    main: { userData },
  } = useSelector((state) => state);

  const refreshInterval = useRef(null);
  const cardsDataRef = useRef(cardsData);
  const dispatch = useDispatch();

  // همیشه جدیدترین داده‌ها رو توی ref نگه داریم
  useEffect(() => {
    cardsDataRef.current = cardsData;
  }, [cardsData]);

  useEffect(() => {
    if (!active || !cardsData?.length) return;
    const updatePrices = async () => {
      const currentCards = cardsDataRef.current;
      const symbols = currentCards
        ?.filter((item) => item?.SYMBOL_NAME)
        ?.map((item) => item?.SYMBOL_NAME);
      const requestPayload = {
        platform_mode: "trade_assistant",
        user: userData?.["custom:custom_username"],
        email: userData?.["cognito:username"],
        request_type: "get_price_bulk",
        market_type: "crypto",
        symbol_names: symbols,
      };
      const url =
        "https://tgh7aum9h0.execute-api.ap-southeast-2.amazonaws.com/dev/api";

      try {
        const res = await axios.post(url, requestPayload);

        const priceData = res?.data?.PRICE_LIST;
        const priceList = priceData.map((item) => item?.PRICE);

        setCardsData((prevData) =>
          prevData.map((item, i) => {
            if (!priceList[i] || priceList[i] === "N/A") return item;

            const tradeType = item?.TRADE_TYPE;
            const priceColor =
              item?.CURRENT_PRICE < priceList[i] ? "#70AF85" : "#EF4B4B";

            return {
              ...item,
              CURRENT_PRICE: priceList[i],
              STOP_LOSS: refreshLimit(
                item.STOP_LOSS_PERCENT * stopLossCFC,
                priceList[i],
                tradeType,
                "stopLoss",
              ),
              TAKE_PROFIT: refreshLimit(
                item.TAKE_PROFIT_PERCENT * takeProfitCFC,
                priceList[i],
                tradeType,
                "takeProfit",
              ),
              priceColor,
            };
          }),
        );
      } catch (err) {
        const { STATUS_CODE, MESSAGE } = err?.response?.data || {};
        if (STATUS_CODE === 502 || STATUS_CODE === 410 || STATUS_CODE === 413) {
          dispatch(
            logErrorToTelegram(
              userData?.["custom:custom_username"],
              userData?.["cognito:username"],
              STATUS_CODE,
              formatTelegramLog("get_price_bulk", requestPayload, url),
              err?.response?.data,
              window.location.href,
              false,
            ),
          );
          return;
        }
        if (MESSAGE) errorHandler(STATUS_CODE, MESSAGE);
      }
    };

    // updatePrices(); // First call immediately
    refreshInterval.current = setInterval(updatePrices, 60000);

    return () => {
      if (refreshInterval.current) clearInterval(refreshInterval.current);
    };
  }, [stopLossCFC, takeProfitCFC, userData, active, setCardsData, cardsData]);
};

export default usePriceRefresh;
